export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "correct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Correct"])},
        "excellent_answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🎉 Excellente réponse !"])},
        "explanation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["💡 Explication"])},
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["← Précédent"])},
        "finish_quiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Terminer le quiz 🎯"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suivant →"])}
      },
      "en": {
        "correct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Correct"])},
        "excellent_answer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["🎉 Excellent answer!"])},
        "explanation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["💡 Explanation"])},
        "previous": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["← Previous"])},
        "finish_quiz": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finish the quiz 🎯"])},
        "next": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Next →"])}
      }
    }
  })
}
